import { css } from 'lit';

export const style = css`
  @media (width >= 744px) {
    .checkout-name-edit {
      display: flex;
    }

    fs-text-field {
      width: 50%;
    }

    .first-name {
      margin-right: 1rem;
    }
  }

  fs-text-field {
    margin-bottom: 1rem;
  }
`;
